import React, { useCallback } from 'react'
import styled from 'styled-components'

import { useHapticFeedback } from '@blade/ui-kit'
import { PairIcon } from '@root/entities/pair/ui/common'
import { PairHeadline } from '@root/features/pair/ui/mobile/pair-headline'
import { PairSubline } from '@root/features/pair/ui/mobile/pair-subline'

import { CurrencyIcon } from '../currency-icon'

import type { CurrencyModel } from '../../model'
import type { PairModel } from '@root/entities/pair'

type Props = {
  currency: CurrencyModel
  pair: PairModel | undefined
  onClick?: (currency: CurrencyModel) => void
  endContent?: React.ReactNode
}
export const CurrencyListItem: React.FC<Props> = ({
  currency,
  endContent,
  onClick,
  pair,
}) => {
  const haptics = useHapticFeedback()
  const handleClick = useCallback(() => {
    if (onClick) {
      haptics.impactOccurred('light')
      onClick(currency)
    }
  }, [currency, haptics, onClick])

  const renderCurrencyIcon = () => {
    if (pair) {
      return <PairIcon size={35} pair={pair} />
    }
    return <CurrencyIcon size={35} currency={currency} outline="outline" />
  }

  const renderTicker = () => {
    if (!pair) {
      return <PairHeadline currency={currency} />
    }

    return <PairHeadline pair={pair} />
  }

  return (
    <CurrencyListItemRoot onClick={handleClick}>
      {renderCurrencyIcon()}
      <Middle>
        {renderTicker()}
        {pair ? (
          <PairSubline pair={pair} />
        ) : (
          <PairSubline currency={currency} />
        )}
      </Middle>
      {endContent}
    </CurrencyListItemRoot>
  )
}

const CurrencyListItemRoot = styled.div`
  cursor: pointer;
  display: grid;
  padding-inline: 12px;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  height: 56px;
  border-bottom: 1px solid rgba(255 255 255 / 5%);

  &:hover {
    background: var(--backgroundA-2);
  }
  &:last-child {
    border-bottom: none;
  }
`

const Middle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-inline-start: 8px;
  gap: 1px;
`
